// Touchpoints live under the Growth nav group, not Risk: they are
// contact-keyed engagement records with no risk relationship, and the
// backend's authz taxonomy already files them under the "growth" write
// area (matt-issue 17). The tab components stay in Risk/ until the
// item-18 branch lands to avoid a directory-move collision. Growth
// opportunities are surfaced here (not on Risk) to match the mockup's
// Touchpoints screen: Customer + Growth subtabs.
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraTabBar, SpecraTabPanel } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
import { useState } from 'react';
import { PageBody } from '../../../../components/layout';
import { useProgramContext } from '../../../../layouts/ProgramLayout';
import { CustomerTouchpointsTab } from '../../Risk/CustomerTouchpointsTab';
import { GrowthOpportunitiesTab } from '../../Risk/GrowthOpportunitiesTab';
export function TouchpointsPage() {
    const { programId } = useProgramContext();
    const [active, setActive] = useState('customer');
    return /*#__PURE__*/ _jsx(PageBody, {
        children: /*#__PURE__*/ _jsxs("div", {
            children: [
                /*#__PURE__*/ _jsx(SpecraTabBar, {
                    idBase: "touchpoints",
                    value: active,
                    onValueChange: setActive,
                    options: [
                        {
                            value: 'customer',
                            label: 'Touchpoints',
                            testId: Testids.deliveryTouchpoints.subTabCustomer
                        },
                        {
                            value: 'growth',
                            label: 'Growth Opportunities',
                            testId: Testids.deliveryTouchpoints.subTabGrowth
                        }
                    ]
                }),
                /*#__PURE__*/ _jsx(SpecraTabPanel, {
                    active: active === 'customer',
                    idBase: "touchpoints",
                    value: "customer",
                    className: "mt-6",
                    children: /*#__PURE__*/ _jsx(CustomerTouchpointsTab, {
                        programId: programId
                    })
                }),
                /*#__PURE__*/ _jsx(SpecraTabPanel, {
                    active: active === 'growth',
                    idBase: "touchpoints",
                    value: "growth",
                    className: "mt-6",
                    children: /*#__PURE__*/ _jsx(GrowthOpportunitiesTab, {
                        programId: programId
                    })
                })
            ]
        })
    });
}
